import { loadCacheFromLocalStorage, toRestoreGridPage } from '../../../../helpers/localStorage';
import { INITIAL_SORT, ALL_COLUMNS, INITIAL_FILTERS, INITIAL_PAGE } from '../constants';

// eslint-disable-next-line import/prefer-default-export
export const getInitialData = ({ cacheKey, buildingId, accountId, inspectionId }) => {
  const cache = loadCacheFromLocalStorage(cacheKey);
  if (cacheIsValid(cache, cacheKey)) {
    return { ...cache, loading: true, page: toRestoreGridPage() && cache.page ? cache.page : INITIAL_PAGE, search: '' };
  }

  return {
    page: INITIAL_PAGE,
    sort: INITIAL_SORT,
    filters: getInitialFilters(buildingId, accountId, inspectionId),
    columns: getInitialColumns(buildingId, accountId, inspectionId),
    search: '',
    loading: true
  };
};

const cacheIsValid = (cache, cacheKey) => {
  if (!cache) return false;

  if (cache?.filters && cache?.sort && !cache.columns.includes('selected')) return true;

  localStorage.removeItem(cacheKey);
  return false;
};

export const getInitialFilters = (buildingId, accountId, inspectionId) => {
  if (buildingId) {
    return { ...INITIAL_FILTERS, values: { ...INITIAL_FILTERS.values, building: buildingId } };
  }
  if (accountId) {
    return { ...INITIAL_FILTERS, values: { ...INITIAL_FILTERS.values, account: accountId } };
  }
  if (inspectionId) {
    return { ...INITIAL_FILTERS, values: { ...INITIAL_FILTERS.values, inspection: inspectionId } };
  }
  return INITIAL_FILTERS;
};

const getInitialColumns = (buildingId, accountId, inspectionId) => {
  let columns = ALL_COLUMNS.filter((column) => column !== 'proposalType' && column !== 'createdBy' && column !== 'lastModifiedBy');
  if (buildingId || inspectionId) {
    columns = columns.filter((column) => column !== 'building');
  }
  if (accountId) {
    columns = columns.filter((column) => column !== 'account');
  }
  return columns;
};
